import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { app } from '../../config';
import CalenderImg from '../../assets/images/calender.png'
import { useNavigate } from 'react-router-dom';
import { Pagination, Input, Form, Select, Row, Col, Space, Spin, message, Collapse, DatePicker } from 'antd';
//Collapse
import { CaretRightOutlined, CaretDownOutlined, SettingOutlined } from '@ant-design/icons'
import moment from 'moment';
//Collapse End
import { useTranslation } from 'react-i18next';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { EditTwoTone, BranchesOutlined } from '@ant-design/icons';
import getHeaders from '../../utils/authHeaders';
import ListinngCard from '../../layouts/ListingCard';
import { dateConverter } from '../../utils/utcDateConversionCommon';

import EcommerceDashboardCard from '../../layouts/EcommerceDashboardCard';
import NoDataFound from '../../layouts/NoDataFound';

const EcommerceDashboard = () => {
    const { RangePicker } = DatePicker;
    const [activeIndex, setActiveIndex] = useState(1);
    const [cancelShow, setCancelShow] = useState(false);
    const [editbtn, setEditBtn] = useState('none');
    const [pageSize, setPageSize] = useState(10);
    const [fetchPartners, setFetchPartners] = useState([]);
    const [subOrderObj, setSubOrderObj] = useState({})
    const [pagesCount, setPagesCount] = useState(0);
    const [searchShow, setSearchShow] = useState({});
    const [renderList, setRenderList] = useState([]);
    const [tableShow, setTableShow] = useState(true);
    const [activeKey, setActiveKey] = useState(['1']);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchItems, setSearchItems] = useState([]);
    const [err, setErr] = useState('');
    const [tableHeaders, setTableHeaders] = useState([]);
    const [show, setShow] = useState(false);
    const [lockModalShow, setLockModalShow] = useState(false);
    const [delBatchResp, setDelBatchResp] = useState({});
    const [lockBatchResp, setLockBatchResp] = useState({});
    const [status, setStatus] = useState([])
    const [dashboardCardsCounts, setDashboardCardsCounts] = useState({
        totalInProgress: 0,
        totalInTransit: 0,
        totalDelivered: 0,
        totalCancelled: 0,
        totalReturnClaim: 0,


    })
    const [cancelData, setCancelData] = useState({})
    const [orderCancelResp, setOrderCancelResp] = useState();
    const [cancelStatus, setCancelStatus] = useState(false)

    const [reciveBackData, setReciveBackData] = useState({})
    const [reciveBackResp, setReciveBackResp] = useState();
    const [reciveBackStatus, setReciveBackStatus] = useState(false)
    const [reciveBackShow, setReciveBackShow] = useState(false)
    const [isRecivedBack,setIsReciveBack]=useState(false)

    const [resendOrderData,setResendOrderData]=useState({})
    const [resendOrderResp,setResendOrderResp]=useState()
    const [resendOrderStatus,setResendOrderStatus]=useState(false);
    const [resendOrderShow,setResendOrderShow]=useState(false);

    const [missingItem,setMissingItem]=useState(false);


    const [stockOutResp, setStockOutResp] = useState([])
    const [dispatchData, setDispatchData] = useState([])
    const [dispatchShow, setDispatchShow] = useState(false);
    const [refreshPage, setRefreshPage] = useState(false);
    const [singleOrderOBj, setSingleOrderObj] = useState({})
    const [showSingleOrder, setShowSingleOrder] = useState(false)


    const handleClose = () => setShow(false);
    const handleLockClose = () => setLockModalShow(false);

    let navigate = useNavigate();
    let convertedObj;

    let searchFilters = [
        {
            fieldName: 'Batch No.',
            fieldMappedBy: 'batchno',
        },
        {
            fieldName: 'Product',
            fieldMappedBy: 'serialNo',
        },
        {
            fieldName: 'Partner Name',
            fieldMappedBy: 'partnerName',
        },
        {
            fieldName: 'Date',
            fieldMappedBy: 'date'
        },

    ];

    let inProgressHeaders = ['Order No.', 'Date', 'Customer', 'Total Ship Cost', 'Total Ship Tax', 'Total Product Cost', 'Total Product Tax', 'Total Amount', "Action"]
    let inTransitHeaders = ['Order No.', 'Date', 'Customer', 'Total Amount', "Action"]
    let deliveredHeaders =['Order No.', 'Date', 'Customer', 'Total Amount', "Action"]
    let customerRequestHeaders = ['Request Type', 'Order No.', 'Sub Order No.', 'Customer Name', 'Request Date', 'Request Status', 'Action', '']
    let cancelledHeaders = ['Order No.', 'Date', 'Customer', 'Total Amount', "Action"]


    let headersMap = new Map()
    headersMap.set(1, inProgressHeaders);
    headersMap.set(2, inTransitHeaders);
    headersMap.set(3, deliveredHeaders);
    headersMap.set(4, customerRequestHeaders);
    headersMap.set(5, cancelledHeaders);
    useEffect(() => {
        setSearchItems(searchFilters);
    }, [])

    // {{base_url}}/api/v1/admin/ecomorders/orderscount
    let statusArr = [];



    useEffect(() => {
        const getState = async () => {
            const statusResp = await axios.get(`${app.URL}/api/v1/admin/ecomorders/orderscount`, { headers: getHeaders() });
            statusResp.data ? console.log(statusResp.data.result.data) : console.log("data");
            statusResp.status == 200 ? setStatus(statusResp.data.result.data) : " ";
            console.log(status)
        }
        getState();
    }, [])
    console.log(status)

    const user = JSON.parse(localStorage.getItem('user'));
    if (user.userType === 'A') setEditBtn('block');
    const userRequestListingAPI = async (formData) => {
        console.log(formData);
        const partnerResp = await axios.post(`${app.URL}/api/v1/admin/userrequest/view`, formData, { headers: getHeaders() });
        // console.log(partnerResp)
        partnerResp ? console.log(partnerResp.data.result.data) : "";
        partnerResp ? convertedObj = dateConverter(partnerResp.data.result.data.data, "createdAt") : " ";
        partnerResp.data.result ? setFetchPartners(convertedObj) : ' ';
        partnerResp.data.result ? setPagesCount(partnerResp.data.result.data.count) : ' ';
        partnerResp.data.result ? setRenderList(convertedObj) : ' ';
    };
    const inventoryListingApi = async (formData, statusId = 2) => {
        console.log(formData);
        // setActiveIndex(1);
        const partnerResp = await axios.post(`${app.URL}/api/v1/admin/ecomorders/vieworders/2`, formData, { headers: getHeaders() });
        // console.log(partnerResp)
        partnerResp ? console.log(partnerResp.data.result.data) : "";
        partnerResp ? convertedObj = dateConverter(partnerResp.data.result.data.data, "createdAt") : " ";
        partnerResp.data.result ? setFetchPartners(convertedObj) : ' ';
        partnerResp.data.result ? setPagesCount(partnerResp.data.result.data.count) : ' ';
        partnerResp.data.result ? setRenderList(convertedObj) : ' ';
    };
    const getData = async () => {
        let formData = {
            limit: pageSize,
            offset: 0,
            searchBy: '',
            searchTxt: '',
        };
        console.log(formData);
        const partnerResp = await axios.post(`${app.URL}/api/v1/admin/userrequest/view`, formData, { headers: getHeaders() });
        console.log(partnerResp)
        partnerResp ? console.log(partnerResp.data.result.data) : " ";
        partnerResp.data.result ? convertedObj = await dateConverter(partnerResp.data.result.data.data, "createdAt") : " ";
        partnerResp.data.result ? setFetchPartners(convertedObj) : ' ';
        partnerResp.data.result ? setPagesCount(partnerResp.data.result.data.count) : ' ';
        partnerResp.data.result ? setRenderList(convertedObj) : ' ';
        return (console.log("return called"))
    }
    const onRequestChange = async (page, pageSize) => {
        console.log(page, pageSize);
        setPageSize(pageSize);
        setCurrentPage(page);
        if (!page) page = 1;
        let limit = pageSize;
        try {
            let reqObj;
            if (Object.keys(searchShow).length !== 0) {
                reqObj = {
                    limit: limit,
                    offset: limit * (page - 1),
                    searchBy: searchShow.searchFor,
                    searchTxt: searchShow.searchItem,
                };
            } else {
                reqObj = {
                    limit: limit,
                    offset: limit * (page - 1),
                    searchBy: 'orderNo.',
                    searchTxt: '',
                };
            }
            console.log(reqObj);
            await userRequestListingAPI(reqObj);
        } catch (e) {
            console.log('Error');
            if (e.message) setErr(e.message);
            setTableShow(false);
        }
    };
    const onChange = async (page, pageSize) => {
        console.log(page, pageSize);
        setPageSize(pageSize);
        setCurrentPage(page);
        if (!page) page = 1;
        let limit = pageSize;
        try {
            let reqObj;
            if (Object.keys(searchShow).length !== 0) {
                reqObj = {
                    limit: limit,
                    offset: limit * (page - 1),
                    searchBy: searchShow.searchFor,
                    searchTxt: searchShow.searchItem,
                };
            } else {
                reqObj = {
                    limit: limit,
                    offset: limit * (page - 1),
                    searchBy: 'orderNo.',
                    searchTxt: '',
                };
            }
            console.log(reqObj);
            await inventoryListingApi(reqObj, activeIndex + 1);
        } catch (e) {
            console.log('Error');
            if (e.message) setErr(e.message);
            setTableShow(false);
        }
    };

    //Approve and Refund Workflow
    const handleCancelModalClose = () => setCancelShow(false);
    const cancelShipment = async (data) => {
        try {
            let resp = await axios.post(`${app.URL}/api/v1/admin/userrequest/cancelshipment`, data, { headers: getHeaders() });
            console.log("resp");
            setOrderCancelResp(resp.data.result);
            setCancelStatus(true)
            setTimeout(() => {
                setCancelShow(false);
            }, 500)
            await getData()
        }
        catch (e) {
            throw e
        }
    }
    const onCancelTrigger = (data) => {
        setOrderCancelResp({});
        console.log(data);
        let cancelObj = {
            requestId: data.requestId,
            patientId: data.patientId,
            ecomOrderId: data.ecomOrderId,
            addressId: data.addressId
        }

        console.log(cancelObj);
        setCancelShow(true);
        setCancelData(cancelObj);
    }
    const onCancelClick = async () => {
        console.log(cancelData);
        await cancelShipment(cancelData)


    }
    // Recive back order work flow


    const handleReciveBackModalClose = () => setReciveBackShow(false);
    const reciveorder = async (data) => {
        try {
            let resp = await axios.post(`${app.URL}/api/v1/admin/ecomorders/receiveback`, data, { headers: getHeaders() });
            console.log("resp");
            setReciveBackResp(resp.data.result);
            setReciveBackStatus(true)
            setTimeout(() => {
                setReciveBackShow(false);
            }, 500)
            await getData()
        }
        catch (e) {
            throw e
        }
    }
    const onReciveBackTrigger = (data) => {
        setReciveBackResp({});
        console.log(data);
        let recivebackObj = {
            requestId: data.requestId,
            patientId: data.patientId,
            ecomOrderId: data.ecomOrderId,
            addressId: data.addressId
        }

        console.log(recivebackObj);
        setReciveBackShow(true);
        setReciveBackData(recivebackObj);
    }
    const onReciveBackClick = async () => {
        console.log(reciveBackData);
         await reciveorder(reciveBackData)


    }

    //Recive back order workflow end





    //Resend Order Workflow

    const handleResendOrderModal = () => setResendOrderShow(false);
    const resendOrder = async (data) => {
        try {
            let resp = await axios.post(`${app.URL}/api/v1/admin/ecomorders/resendorder`, data, { headers: getHeaders() });
            console.log("resp");
            setResendOrderResp(resp.data.result);
            setResendOrderStatus(true)
            setTimeout(() => {
                setResendOrderShow(false);
            }, 500)
            await getData()
        }
        catch (e) {
            throw e
        }
    }
    const onResendOrderTrigger = (data) => {
        setResendOrderResp({});
        console.log(data);
        if(data.requestType=="Missing Item"||data.requestType=="missing item"){
            setMissingItem(true)
        }
        let resendOrderObj = {
            requestId: data.requestId,
            patientId: data.patientId,
            ecomOrderId: data.ecomOrderId,
            addressId: data.addressId
        }

        console.log(resendOrderObj);
        setResendOrderShow(true);
        setResendOrderData(resendOrderObj);
    }
    const onResendOrderonClick = async () => {
        console.log(resendOrderData);
         await resendOrder(resendOrderData)


    }

    //Resend Order Work flow End
    console.log(renderList)
    useEffect(() => {
        setTableHeaders(headersMap.get(1));
        setActiveIndex(1);
        setActiveKey(["1"])
        const getData = async () => {
            let formData = {
                limit: pageSize,
                offset: 0,
                searchBy: '',
                searchTxt: '',
            };
            console.log(formData);
            const partnerResp = await axios.post(`${app.URL}/api/v1/admin/ecomorders/vieworders/2`, formData, { headers: getHeaders() });
            const inTransitResp = await axios.post(`${app.URL}/api/v1/admin/ecomorders/vieworders/3`, formData, { headers: getHeaders() });

            setDashboardCardsCounts(prevCounts => ({
                ...prevCounts,
                totalInProgress: partnerResp.data.result.data.count,
                totalInTransit: inTransitResp.data.result.data.count
            }));
            console.log(partnerResp)
            partnerResp ? console.log(partnerResp.data.result.data) : " ";
            partnerResp.data.result ? convertedObj = await dateConverter(partnerResp.data.result.data.data, "createdAt") : " ";
            partnerResp.data.result ? setFetchPartners(convertedObj) : ' ';
            partnerResp.data.result ? setPagesCount(partnerResp.data.result.data.count) : ' ';
            partnerResp.data.result ? setRenderList(convertedObj) : ' ';
            return (console.log("return called"))
        }
        getData()
    }, [])

    useEffect(() => {
        let searchFilters = [
            {
                fieldName: 'Order No.',
                fieldMappedBy: 'orderNo',
            },
            {
                fieldName: 'Customer Name',
                fieldMappedBy: 'patientName',
            },
            {
                fieldName: 'Status',
                fieldMappedBy: 'patientName',
            },
        ];
        setSearchItems(searchFilters);
    }, [])

    const { Panel } = Collapse;
    const customExpandIcon = (panelProps) => {
        const { isActive } = panelProps;

        return (
            <span>
                {isActive ? <CaretDownOutlined /> : <CaretRightOutlined />}
            </span>
        );
    }
    const onFinish = async (values) => {
        console.log(values);
        setSearchShow(values);
        try {
            let searchData = {
                limit: 10,
                offset: 0,
                searchBy: values.searchFor,
                searchTxt: values.searchItem,
            };
            if (!searchData.searchBy) message.error("Select search criteria ")
            if (searchData.searchBy) await inventoryListingApi(searchData);
        } catch (e) {
            console.log('Error');
            if (e.message) setErr(e.message);
            setTableShow(false);
        }
    };
    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    const onCollapseChange = async (key) => {
        console.log('Collapse change:', key);
        console.log("KEEYYYYYYYYYYYY")
        console.log(key);
        // setSubOrderObj({})
        // const orderResp = await axios.post(`${app.URL}/api/v1/app/ecomorderdetails/view/${key}`, {}, { headers: getHeaders() });
        // console.log(orderResp)
        // let converArr = [];
        // orderResp.data.code == 200 ? converArr.push(orderResp.data.data) : " ";
        // orderResp.data.code == 200 ? convertedObj = await dateConverter(converArr, "orderDate") : " ";
        // orderResp.data.code == 200 ? setSubOrderObj(convertedObj[0]) : " "
    };
    console.log(subOrderObj)
    const onViewClick = (data) => {
        console.log("onViewClick")
        console.log(data.ecomOrderId)
        localStorage.setItem("orderId", JSON.stringify(data.ecomOrderId));
        navigate('/ecomorders/view', { replace: true })
    }

    const onSearchFinish = async (values) => {
        console.log('onSearchFinish');
        console.log('Success:', values);
        let formData = {
            "limit": 10,
            "offset": 0,
            "searchBy": values.searchBy, //partnerName, serialNo, orderNo
            "searchTxt": values.searchTxt,
            "status": activeIndex, //1 = In-Transit (Inprogress), 2 = Sent to Lab, 3 = Completed
            "orderDateFrom": orderDateFrom ? orderDateFrom : "", //2023-03-03  only give date without time
            "orderDateTo": orderDateTo ? orderDateTo : ""
        }
        if (!formData.searchBy) message.error("Khuch select ker kutte");
        await dashboardListingApi(formData)
    }

    const onSearchFinishFailed = (values) => {
        console.log('Failed:', values);
    }
const onInProgressClick=()=>{
    setActiveIndex(1);
    navigate("/ecom/dashboard/inprogress",{replace: true});
}
const onInTransitClick=()=>{
    setActiveIndex(2);
    navigate("/ecom/dashboard/intransit",{replace: true});
}



    const onCardClick = async (index) => {
        setActiveIndex(index);
        // console.log("active Index ", index)
        setTableHeaders(headersMap.get(index))
        let formData = {
            limit: pageSize,
            offset: 0,
            searchBy: 'orderNo.',
            searchTxt: '',
        };

        console.log("index before: ", index);

        index == 5 ? await inventoryListingApi(formData, 5) : await inventoryListingApi(formData, index + 1);;


        console.log("index after: ", index);

    }
    const onRequestClick = async (index) => {
        setActiveIndex(index);
        setTableHeaders(headersMap.get(index))
        await getData()
    }


    const stockOut = async (data) => {
        try {
            let resp = await axios.post(`${app.URL}/api/v1/admin/stockout/create`, data, { headers: getHeaders() });
            console.log("resp");
            setStockOutResp(resp.data.result);
            setDispatchShow(true);
            setTimeout(() => {
                setRefreshPage(!refreshPage)
                setDispatchShow(!dispatchShow);

            }, 500)

        }
        catch (e) {
            throw e
        }
    }

    const onDispatchTrigger = (data) => {
        console.log("dispatch data: ", data);
        setDispatchShow(!dispatchShow);
        setDispatchData(data);

    }

    const onDispatchClick = async () => {
        // console.log("data")
        // console.log(data)
        console.log(dispatchData);
        let stockOutArr = [];
        dispatchData.products.forEach((ele) => {
            stockOutArr.push({
                "productId": ele.productId,
                "quantity": ele.quantity,
                "unitPrice": ele.unitPrice,
                "patientId": subOrderObj.patientId,
                "ecomOrderId": subOrderObj.ecomOrderId,
                "addressId": dispatchData.addressId,
            })
        })

        await stockOut(stockOutArr)
        console.log("stock out resp: ", stockOutResp);
        // console.log(stockOutResp)


    }

    const onIntransitClick = async () => {
    // console.log("data")
    // console.log(data)
    console.log(dispatchData);
    let stockOutArr = [];
    dispatchData.products.forEach((ele) => {
        stockOutArr.push({
            "productId": ele.productId,
            "quantity": ele.quantity,
            "unitPrice": ele.unitPrice,
            "patientId": subOrderObj.patientId,
            "ecomOrderId": subOrderObj.ecomOrderId,
            "addressId": dispatchData.addressId,
        })
    })

    await stockOut(stockOutArr)
    console.log("stock out resp: ", stockOutResp);
    // console.log(stockOutResp)


}


    const genExtra = (order) => {
        console.log("Gen Extra")
        console.log(order)
      return  (
            <>
                <table id="">
                    <tbody>
                        <tr>
                          <td style={{ width: '200px' }}><a>{order.ecomOrderNo}</a></td>
                          <td style={{ width: '190px' }}><a>{order.createdAt}</a></td>
                          <td style={{ width: '210px' }}>{order.patientName}</td>
                          <td style={{ width: '200px' }}>{"299"}</td>
                          <td style={{ width: '200px' }}>{"19"}</td>
                          <td style={{ width: '200px' }}>{"220"}</td>
                          <td style={{ width: '200px' }}>{"75"}</td>
                          <td style={{ width: '170px' }}>{Number(order.productTotalAmount)}</td>
                            {/* <td style={{ width: '100px' }}>{order.orderStatus ? order.orderStatus : null}</td> */}
                        </tr>
                    </tbody>
                </table>
            </>
        );

    }


    return (
        <div className='for-pseudo ml-3 col-lg-12 col-md-12 col-sm-12' style={{ backgroundColor: "#fff", borderRadius: "10px", marginBottom: "20px" }}>
            <div className='row' style={{ paddingRight: "10px" }}>
                <div className="for-before col-lg-4 head fs-3 fw-bold" style={{ backgroundColor: "#a7c1d9", borderBottomRightRadius: "10px", color: "#FFFFFF" }}>
                    Ecommerce Dashboard
                </div>
                <div className="col-lg-5" style={{ margin: "auto", marginTop: "20px" }}>
                    <RangePicker onChange={onChange} />
                </div>
                <div className="col-lg-3 d-flex align-end" style={{ margin: "auto", marginTop: "20px", position: "relative" }}>
                    <img className='calender-img' src={CalenderImg} />
                    <select className="form-control drop-down-select" name="dates" id="date" onChange={(e) => dateSelect(e.target.value)}>
                        <option value={moment().subtract(24, "hours").format("YYYY-MM-DD")}>last 24 hours</option>
                        <option value={moment().subtract(7, "d").format("YYYY-MM-DD")}>last week</option>
                        <option value={moment().subtract(1, "months").format("YYYY-MM-DD")}>last month</option>
                        <option value={moment().subtract(1, "year").format("YYYY-MM-DD")}>last year</option>
                    </select>
                </div>
            </div>
            <div style={{ paddingBottom: "50px", paddingLeft: "50px" }}>
                <div className="row" style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "5%",
                    marginLeft: "-6.5%",

                }}>
                    <div style={{
                        position: "relative",
                        height: "400px !important"
                    }} className="col-lg-2 mb-2" onClick={() => onInProgressClick()}>
                        <EcommerceDashboardCard
                            count={status.length > 1 ? status[1].count : 0}
                            isActive={activeIndex == 1}
                            activatedProducts={true}
                            awaitingProducts={false}
                            cardName={"In Progress"}
                        />
                    </div>
                    <div style={{ position: "relative" }} className="col-lg-2 mb-4" onClick={() => onInTransitClick()}>
                        <EcommerceDashboardCard
                            count={status.length > 1 ? status[2].count : 0}
                            isActive={activeIndex == 2}
                            activatedProducts={true}
                            awaitingProducts={false}
                            cardName={"In Transit"}
                        />
                    </div>
                    <div style={{ position: "relative" }} className="col-lg-2 mb-4" onClick={() => onCardClick(3)}>
                        <EcommerceDashboardCard
                            count={status.length > 1 ? status[3].count : 0}
                            isActive={activeIndex == 3}
                            activatedProducts={false}
                            awaitingProducts={true}
                            cardName={"Delivered"}
                        />
                    </div>
                    <div style={{ position: "relative", maxHeight: "150px" }} className="col-lg-2 mb-4" onClick={() => onRequestClick(4)}>
                        <EcommerceDashboardCard
                            count={status.length > 1 ? status[status.length - 1].requestCount : 0}
                            isActive={activeIndex == 4}
                            activatedProducts={false}
                            awaitingProducts={false}
                            cardName={"Request"}
                        />
                    </div>
                    <div style={{ position: "relative" }} className="col-lg-2 mb-4" onClick={() => onCardClick(5)}>
                        <EcommerceDashboardCard
                            count={status.length > 1 ? status[4].count : 0}
                            isActive={activeIndex == 5}
                            activatedProducts={false}
                            awaitingProducts={false}
                            cardName={"Cancelled/Refund"}
                        />
                    </div>


                </div>

                <div className='row' style={{
                    marginLeft: "0.5rem"
                }}>
                    <Form
                        name='basic'
                        labelCol={{
                            span: 8,
                        }}
                        wrapperCol={{
                            span: 8,
                        }}
                        style={{ alignItems: 'flexEnd' }}
                        initialValues={{
                            remember: true,
                        }}
                        className='mt-4'
                        onFinish={onSearchFinish}
                        onFinishFailed={onSearchFinishFailed}
                        autoComplete='off'
                    >
                        <Row gutter={[16, 16]}>
                            <Col style={{ paddingLeft: '0px', paddingRight: '0px' }} span={6}>
                                <Form.Item
                                    colon={false}
                                    name='searchBy'
                                    style={{
                                        width: 700,
                                        paddingLeft: '10px'
                                    }}
                                >
                                    <Select placeholder='Search By'>
                                        <option value="productName">Product </option>
                                        <option value="partnerName">Partner </option>
                                        <option value="serialNo">Serial No.</option>
                                        <option value="orderNo">Order No.</option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col style={{ paddingLeft: '0px', paddingRight: '0px' }} span={5}>
                                <Form.Item
                                    name='searchTxt'
                                    style={{
                                        width: 700,
                                        paddingLeft: '10px'
                                    }}
                                >
                                    <Input placeholder='Enter value for search' />
                                </Form.Item>
                            </Col>

                            <Col style={{ paddingLeft: '0px', paddingRight: '0px' }} span={3}>
                                <Form.Item
                                    colon={false}
                                    wrapperCol={{
                                        offset: 8,
                                        span: 16,
                                    }}
                                >
                                    <button type='primary' class='btn btn-primary button' htmlType='submit'>
                                        Search
                                    </button>
                                </Form.Item>
                            </Col>
                            <Col style={{ paddingLeft: '0px', paddingRight: '0px' }} span={3}>
                            </Col>
                        </Row>
                    </Form>
                </div>

                {/* orders table to copy*/}
                {activeIndex !== 4 ? <div className='col-lg-11 col-md-12 col-sm-12 '>
                    <div>
                        <div>
                            <table id="customers" style={{
                                padding: "5px 0px"
                            }}>
                                <thead >
                                    {tableHeaders.map(header => (
                                        <th style={{ width: "220px", textAlign: "left", paddingLeft: "20px" }}>{header}</th>
                                    ))}
                                </thead>
                            </table>
                        </div>
                        {renderList ? <Collapse accordion obClexpandIcon={customExpandIcon} onChange={(key)=>{onCollapseChange(renderList[key])}} >
                            {renderList.map((order, index) => (
                                <Panel onClick={(e) => { e.stopPropagation() 
                                    setSubOrderObj(order);

                                }} header={genExtra(order)} key={order.ecomOrderId} extra={
                                    <><Button onClick={() => { onViewClick(order) }} style={{ width: "70px", height: "34px", fontSize: "small", marginRight: "30px" }} size="medium">
                                        View
                                    </Button></>
                                }>
                                    {/* //Single Order Object */}
                                    {Object.keys(subOrderObj).length > 0 ?
                                        <>
                                            {/* <div class="row mb-3">
                        <div class="col-lg-6">
                          Order No: {subOrderObj.ecomOrderNo}
                        </div>
                        <div class="col-lg-6 text-right">
                          Order Date:{subOrderObj.orderDate}
                        </div>
                      </div> */}
                                            {/* <div class="row mb-4">
                        <div class="col-lg-6">
                          Status: <span style={{ color: "white", border: "1px green", backgroundColor: "#04AA6D", borderRadius: "15px", padding: "10px" }}>{subOrderObj.ecomOrderStatus}</span>
                        </div>
                      </div> */}
                                            {/* <div className='row'>
                              <div className='col-lg-6 pl-9 fw-bold fs-5' style={{ color: "#6a6a6a" }}>{ele.addressTitle}</div>
                              <div className='col-lg-6 text-right'>
                                Sub Status: <span style={{ color: "white", border: "1px green", backgroundColor: "#04AA6D", borderRadius: "15px", padding: "10px" }}>{ele.subOrderStatus}</span>
                              </div>
                              <div className='row'>
                                <div className='col-lg-12 pl-9' style={{ color: "#6a6a6a" }}>
                                  {ele.address}
                                </div>
                                {ele.product.map((ele) => (
                                  <table id="customers">
                                    <thead class=''>
                                      <tr>
                                        <th>Product</th>
                                        <th>Quantity</th>
                                        <th>Price</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td style={{ width: '200px' }}><a>{ele.productName}</a></td>
                                        <td style={{ width: '200px' }}><a>{ele.quantity}</a></td>
                                        <td style={{ width: '200px' }}>{ele.unitPrice}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                ))}
                                <div className='row'>
                                  <div className='col-lg-12 text-right'>Shipment Package: {subOrderObj.shipmentPackage}</div>
                                  <div className='col-lg-12 text-right'>Total Amount: {subOrderObj.totalAmount.toString()}</div>
                                  <div className='col-lg-12 text-right'>Tax Amount: {subOrderObj.taxAmount}</div>
                                  <div className='col-lg-12 text-right'>Shipment Charges: {subOrderObj.shipmentCharges}</div>
                                  <div className='col-lg-12 text-right'>Grand Total: {subOrderObj.grandTotal}</div>
                                </div>
                              </div>
                            </div> */}


                                            <div className='row'>
                                                <table id="customers" style={{ margin: "2px !important", padding: "0px !important" }}>
                                                    <thead class=''>
                                                        <tr>
                                                            <th>Sub Order No.</th>
                                                            <th>Shipment Address</th>
                                                            <th>Shipment Cost</th>
                                                            <th>Shipment Tax</th>
                                                            <th>Product Cost</th>
                                                            <th>Product Tax</th>
                                                            <th>Status</th>
                                                            <th>Action</th>
                                                            <th></th>
                                                            {/* <th></th>
                              <th></th> */}
                                                        </tr>
                                                    </thead>

                                                    {subOrderObj.address.map((ele) => (
                                                        //<div className='mb-2'>
                                                        <tbody>
                                                            <tr>
                                                                <td style={{ width: '150px' }}><a>{order.ecomOrderNo}-{ele.addressId}</a></td>
                                                                <td style={{ width: '150px' }}>{`${ele.address}, ${ele.state}, ${ele.city}, ${ele.zipCode}`}</td>
                                                                <td style={{ width: '150px' }}>{"486"}</td>
                                                                <td style={{ width: '150px' }}>{"486"}</td>
                                                                <td style={{ width: '150px' }}>{"486"}</td>
                                                                <td style={{ width: '150px' }}>{"486"}</td>

                                                                <td style={{ width: '150px' }}>{ele.status}</td>
                                                                {
                                                                    !ele.requestId ? (
                                                                        <div>
                                                                            <td style={{
                                                                                width: "150px"
                                                                            }}>

                                                                                <>

                                                                                    <Button onClick={() => {

                                                                                        onDispatchTrigger(ele)

                                                                                    }} style={{ width: "70px", height: "34px", fontSize: "small", marginRight: "0px" }} size="medium">
                                                                                        Dispatch
                                                                                    </Button>


                                                                                </>

                                                                            </td>
                                                                            <td>
                                                                                <Button onClick={() => {

                                                                                    setSingleOrderObj(ele);
                                                                                    setShowSingleOrder(true)

                                                                                }} style={{ width: "70px", height: "34px", fontSize: "small", marginRight: "0px" }} size="medium">
                                                                                    View
                                                                                </Button>
                                                                            </td>
                                                                        </div>
                                                                    ) : (
                                                                        <div>
                                                                            <td>
                                                                                <Button onClick={() => {

                                                                                    setSingleOrderObj(ele);
                                                                                    setShowSingleOrder(true)

                                                                                }} style={{ width: "70px", height: "34px", fontSize: "small", marginRight: "0px" }} size="medium">
                                                                                    View
                                                                                </Button>
                                                                            </td>
                                                                        </div>
                                                                    )
                                                                }
                                                                {/* <td style={{ width: '30px' }}><button onClick={() => onViewClick(ele)} style={{ width: "50px", height: "34px", fontSize: "small" }} className='btn btn-primary btn-small'>view</button></td>
                                <td style={{ width: '30px' }}><button onClick={() => onDispatchClick(ele)} style={{ width: "70px", height: "34px", fontSize: "small" }} className='btn btn-primary btn-small'>dispatch</button></td> */}
                                                            </tr>
                                                        </tbody>




                                                        // </div>


                                                    ))}
                                                </table>
                                            </div>

                                        </> : <div className='row text-center'>
                                            <span>  <Space size="middle">
                                                <Spin size="large" />
                                            </Space></span>
                                        </div>


                                    }
                                </Panel>
                            ))}
                        </Collapse> : " "}


                    </div>
                </div> : " "}
                {activeIndex == 4?
                    <div className='col-lg-11 col-md-12 col-sm-12 '>
                        <div>
                            <table id="customers">
                                <thead class=''>
                                    <tr>
                                        <th>Request Type</th>
                                        <th>Order No.</th>
                                        <th>Sub Order No.</th>
                                        <th>Customer Name</th>
                                        <th>Request Date</th>
                                        <th>Request Status</th>
                                        <th></th>
                                          <th></th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {renderList.length>0 ? renderList.map((tableValues) =>(
                                        <tr >
                                            <td style={{ width: '200px', textTransform: "capitalize" }}>{tableValues.requestType ? tableValues.requestType : 'null'}</td>
                                            <td style={{ width: '200px' }}>{tableValues.ecomOrderNo ? tableValues.ecomOrderNo : 'null'}</td>
                                            <td style={{ width: '150px' }}>{tableValues.ecomOrderNo ? tableValues.ecomOrderNo + "-" + tableValues.addressId : 'null'}</td>
                                            <td style={{ width: '150px', textAlign: "center" }}>{tableValues.patientName ? tableValues.patientName : 'null'}</td>
                                            <td style={{ width: '150px' }}>{tableValues.createdAt ? tableValues.createdAt : 'null'}</td>
                                            <td style={{ width: '150px', textTransform: "capitalize" }}>{tableValues.requestStatus ? tableValues.requestStatus : 'null'}</td>
                                            {/* {tableValues.isRecivedBack && tableValues.requestStatus == "Order Recived" && (tableValues.requestType == "Refund" || tableValues.requestType == "refund") ?
                                                <td style={{ width: '100px', textTransform: "capitalize" }}><span>Order Received back</span></td>
                                                : " "} */}

                                            {tableValues.requestStatus == "Pending" && (tableValues.requestType == "Cancel" || tableValues.requestType == "cancel") ?
                                                <td style={{ width: '100px', textTransform: "capitalize" }}><button className="button btn btn-primary" onClick={() => { onCancelTrigger(tableValues) }} style={{ width: "150px", height: "34px", fontSize: "small" }} size="medium"> Approve & Refund
                                                </button></td>
                                                : " "}
                                            {tableValues.requestStatus == "Pending" && (tableValues.requestType == "Refund" || tableValues.requestType == "refund"||tableValues.requestType == "Exchange"||tableValues.requestType == "exchange") ?
                                                <td style={{ width: '100px', textTransform: "capitalize" }}><button className="button btn btn-primary" onClick={() => { onReciveBackTrigger(tableValues) }} style={{ width: "150px", height: "34px", fontSize: "small" }} size="medium"> Recive back order
                                                </button></td>
                                                : " "}
                                                   {tableValues.requestStatus == "Pending" && (tableValues.requestType == "Missing Item" || tableValues.requestType == "missing item"||tableValues.requestType == "Missing Item") ?
                                                <td style={{ width: '100px', textTransform: "capitalize" }}><button className="button btn btn-primary" onClick={() => { onResendOrderTrigger(tableValues) }} style={{ width: "150px", height: "34px", fontSize: "small" }} size="medium"> Send Missing Item
                                                </button></td>
                                                : " "}
                                            {tableValues.isRecivedBack && tableValues.requestStatus == "Order Recived" && (tableValues.requestType == "Refund" || tableValues.requestType == "refund") ?
                                                <td style={{ width: '100px', textTransform: "capitalize" }}><button className="button btn btn-primary" onClick={() => { onCancelTrigger(tableValues) }} style={{ width: "150px", height: "34px", fontSize: "small" }} size="medium"> Approve & Refund
                                                </button></td>
                                                : " "}

                                            {tableValues.isRecivedBack && tableValues.requestStatus == "Order Recived" && (tableValues.requestType == "Exchange" || tableValues.requestType == "exchange") ?
                                                <td style={{ width: '100px', textTransform: "capitalize" }}><button className="button btn btn-primary" onClick={() => { onResendOrderTrigger(tableValues) }} style={{ width: "150px", height: "34px", fontSize: "small" }} size="medium"> Resend Order
                                                </button></td>
                                                : " "}    

                                            <td style={{ width: '100px', textTransform: "capitalize" }}><button className="button btn btn-primary" onClick={() => { onViewClick(tableValues) }} style={{ width: "70px", height: "34px", fontSize: "small" }} size="medium">
                                                View
                                            </button></td>
                                        </tr>
                                    )
                                ):" "}
                                </tbody>
                         
                            </table>
                        </div>
                        {renderList.length==0?<NoDataFound/>:" "}
                    </div>
                    :" "}

                {currentPage && pagesCount ? <Pagination style={{ marginTop: '10px' }} onChange={activeIndex == 4 ? onRequestChange : onChange} defaultCurrent={currentPage} total={pagesCount} showTotal={(total) => `Total ${total} items`} showSizeChanger /> : " "}


                {/* show single sub order modal start */}

                <Modal show={showSingleOrder} onHide={() => {
                    setShowSingleOrder(!showSingleOrder)
                }}
                    centered


                >
                    <Modal.Header
                        closeButton>
                        <Modal.Title className='text-center'>Sub Order No: {subOrderObj.ecomOrderNo}-{singleOrderOBj.addressId}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <h3>Sub Order Title: {singleOrderOBj.title}</h3>
                        <br />
                        <h3>Sub Order Address: {`${singleOrderOBj.address}, ${singleOrderOBj.state}, ${singleOrderOBj.city}, ${singleOrderOBj.zipCode}`}</h3>
                        <br />

                        <h3>Sub Order Status: {singleOrderOBj.status}</h3>

                    </Modal.Body>
                    <Modal.Footer></Modal.Footer>
                </Modal>
                {/* show single sub order modal end */}


                {/* dispatch order modal start */}

                {stockOutResp && stockOutResp.code === 200 ? (
                    <Modal show={dispatchShow} onHide={handleCancelModalClose}>
                        <Modal.Header closeButton>
                            <Modal.Title className='text-center'>Success</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>{stockOutResp.msg}</Modal.Body>
                        <Modal.Footer></Modal.Footer>
                    </Modal>
                ) : stockOutResp && stockOutResp.code === 400 ? (
                    <Modal show={dispatchShow} onHide={handleCancelModalClose}>
                        <Modal.Header closeButton>
                            <Modal.Title className='text-center'>Failed</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>{stockOutResp.msg}</Modal.Body>
                        <Modal.Footer></Modal.Footer>
                    </Modal>
                ) : (
                    <Modal show={dispatchShow} onHide={handleCancelModalClose}>
                        <Modal.Header closeButton>
                            <Modal.Title>Confirmation</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>Are you sure you want to dispatch the shipment?</Modal.Body>
                        <Modal.Footer>
                            <Button variant='secondary' onClick={() => {
                                setDispatchShow(!dispatchShow)
                            }}>
                                Cancel
                            </Button>
                            <Button variant='primary' htmlType='submit' onClick={() => {
                                onDispatchClick();
                            }}>
                                Confirm
                            </Button>
                        </Modal.Footer>
                    </Modal>
                )}

                {/* dispatch order modal end */}

                {/* Cancel Modal */}
                {orderCancelResp && orderCancelResp.code === 200 ? (
                    <Modal show={cancelShow} onHide={handleCancelModalClose}>
                        <Modal.Header closeButton>
                            <Modal.Title className='text-center'>Success</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>{orderCancelResp.msg}</Modal.Body>
                        <Modal.Footer></Modal.Footer>
                    </Modal>
                ) : orderCancelResp && orderCancelResp.code === 400 ? (
                    <Modal show={cancelShow} onHide={handleCancelModalClose}>
                        <Modal.Header closeButton>
                            <Modal.Title className='text-center'>Failed</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>{orderCancelResp.msg}</Modal.Body>
                        <Modal.Footer></Modal.Footer>
                    </Modal>
                ) : (
                    <Modal show={cancelShow} onHide={handleCancelModalClose}>
                        <Modal.Header closeButton>
                            <Modal.Title>Confirmation</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>Are you sure you want to cancel shipment?</Modal.Body>
                        <Modal.Footer>
                            <Button variant='secondary' onClick={handleCancelModalClose}>
                                Cancel
                            </Button>
                            <Button variant='primary' htmlType='submit' onClick={onCancelClick}>
                                Confirm
                            </Button>
                        </Modal.Footer>
                    </Modal>
                )}
                {/* Recive Back Modal */}
                {reciveBackResp && reciveBackResp.code === 200 ? (
                    <Modal show={reciveBackShow} onHide={handleReciveBackModalClose}>
                        <Modal.Header closeButton>
                            <Modal.Title className='text-center'>Success</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>{reciveBackResp.msg}</Modal.Body>
                        <Modal.Footer></Modal.Footer>
                    </Modal>
                ) : reciveBackResp && reciveBackResp.code === 400 ? (
                    <Modal show={reciveBackShow} onHide={handleReciveBackModalClose}>
                        <Modal.Header closeButton>
                            <Modal.Title className='text-center'>Failed</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>{reciveBackResp.msg}</Modal.Body>
                        <Modal.Footer></Modal.Footer>
                    </Modal>
                ) : (
                    <Modal show={reciveBackShow} onHide={handleReciveBackModalClose}>
                        <Modal.Header closeButton>
                            <Modal.Title>Confirmation</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>Are you sure, you want to recive shipment back?</Modal.Body>
                        <Modal.Footer>
                            <Button variant='secondary' onClick={handleReciveBackModalClose}>
                                Cancel
                            </Button>
                            <Button variant='primary' htmlType='submit' onClick={onReciveBackClick}>
                                Confirm
                            </Button>
                        </Modal.Footer>
                    </Modal>
                )}

                  {/* Resend Order Modal */}
                  {resendOrderResp && resendOrderResp.code === 200 ? (
                    <Modal show={resendOrderShow} onHide={handleResendOrderModal}>
                        <Modal.Header closeButton>
                            <Modal.Title className='text-center'>Success</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>{resendOrderResp.msg}</Modal.Body>
                        <Modal.Footer></Modal.Footer>
                    </Modal>
                ) : resendOrderResp && resendOrderResp.code === 400 ? (
                    <Modal show={resendOrderShow} onHide={handleResendOrderModal}>
                        <Modal.Header closeButton>
                            <Modal.Title className='text-center'>Failed</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>{resendOrderResp.msg}</Modal.Body>
                        <Modal.Footer></Modal.Footer>
                    </Modal>
                ) : (
                    <Modal show={resendOrderShow} onHide={handleResendOrderModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Confirmation</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>{missingItem?`Are you sure, you want to send the missing item?`:`Are you sure, you want to resend the order?`}</Modal.Body>
                        <Modal.Footer>
                            <Button variant='secondary' onClick={handleResendOrderModal}>
                                Cancel
                            </Button>
                            <Button variant='primary' htmlType='submit' onClick={onResendOrderonClick}>
                                Confirm
                            </Button>
                        </Modal.Footer>
                    </Modal>
                )}


            </div>
        </div>
    )
}

export default EcommerceDashboard